import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-dynamic-text-input-modal',
  templateUrl: './dynamic-text-input-modal.component.html',
  styleUrls: ['./dynamic-text-input-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DynamicTextInputModalComponent implements OnInit {
  @Input() modalTitle: string;
  @Input() modalDescription:string;
  @Input() modalPlaceHolder:string;
  @Input() inputValue: string;
  @Input() type: string = 'text'; // Type of input: 'text' or 'email'
  @Input() disabled: boolean = false; // Allow disabling the input (read-only)
  
  sendButtonText: string = 'Send'; // Default fallback
  fieldTouched: boolean = false;

  constructor(public activeModal: NgbActiveModal, private translate: TranslateService) { 
  }

  ngOnInit(): void {
    // Ensure translations are loaded
    this.translate.get('ac_send').subscribe((translation: string) => {
      console.log('Translation for ac_send:', translation);
      this.sendButtonText = translation !== 'ac_send' ? translation : 'Send';
    });
  }

  /**
   * Validate email format only if type is 'email'
   */
  isValidEmail(): boolean {
    if (this.type !== 'email' || !this.inputValue) return true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(this.inputValue);
  }

  /**
   * Check if the Send button should be disabled
   */
  isSendButtonDisabled(): boolean {
    if (!this.inputValue) return true;
    if (this.type === 'email') {
      return !this.isValidEmail();
    }
    return false;
  }

  /**
   * Mark field as touched for validation display
   */
  onFieldBlur(): void {
    this.fieldTouched = true;
  }

}
